import { MELCO_HOOP_TYPE } from "../../../helper/hoopHelper";
import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

type HoopTypeSelectProps = {

    onChange?: (obj: string) => void;
    value?: string;

}

export const HoopTypeSelect: React.FC<HoopTypeSelectProps> = ({ onChange, value }) => {
    let options = [];

    const { t } = useTranslation();
    options = MELCO_HOOP_TYPE.split(",").map((t) => {
        return {
            label: t,
            value: t
        }
    })

    return <>

        <SelectField
            name="type"
            options={options}
            style={{ "width": "100%", minWidth: "150px" }}
            allowClear
            placeholder={t("managehoops.tabs.basic.type")}
            onChange={onChange}
            value={value}
        />
    </>
}